import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { LanguagesService, AuthService, HotelConfig, UserHotel } from "@easyfo/common-lib";
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { UsersService } from '../../services/user';
import { HotelService } from '../../services/hotel';
import { CentralizedService } from '../../services/centralized';
import { FrontService } from '../../services/front';
import { ActivatedRoute, Router } from '@angular/router';
import { base64 } from '@firebase/util';

@Component({
  selector: 'app-landing-view',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class LandingComponent implements OnInit {
  constructor(
    private _titleService: Title,
    private _userService: UsersService,
    private _hotelService: HotelService,
    private _centralizedService: CentralizedService,
    private _frontService: FrontService,
    private _languagesService: LanguagesService,
    private _authService: AuthService,
    private _router: Router,
    private _activeRoute: ActivatedRoute,
  ) {
    this._titleService.setTitle("Landing");
    this._languagesService.setByCookies();
    this._languagesService.getText('form_login_app.form_login.fail_msg', (text: string) => {
      this.landingFailMessage = text;
    });
  }

  landingFailMessage: string = "";
  formHotel: FormControl = new FormControl(null, [Validators.required]);
  hotels: UserHotel.HotelResponseDTO[] = [];
  loaded: boolean = false;
  filteringCtrl: FormControl = new FormControl();
  searchingText: string = ''
  redirectURL?: string;

  productsWithImage: Product[] = [
    { index: 1, shortName: "fo", name: "Front Office", href: "/fo/dashboard/", available: true, comingSoon: false, info: "https://easyfo.com/product-pms-web-based-on-cloud.html", image: "https://images.unsplash.com/photo-1660557989695-14fac79c086d?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=764" },
    { index: 2, shortName: "pos", name: "Point Of Sale", href: "/pos/", available: false, comingSoon: true, image: "https://images.unsplash.com/photo-1647427017067-8f33ccbae493?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1170" },
    { index: 3, shortName: "ar", name: "Account Receivable", href: "/ar/", available: false, comingSoon: false, image: "https://cdn.pixabay.com/photo/2019/09/30/15/30/credit-4516068_1280.jpg" },
    { index: 4, shortName: "inv", name: "Inventory", href: "/inv/", available: false, comingSoon: false, image: "https://images.pexels.com/photos/12234107/pexels-photo-12234107.jpeg" },
    { index: 5, shortName: "ap", name: "Account Payable", href: "/ap/", available: false, comingSoon: false, image: "https://images.pexels.com/photos/2988232/pexels-photo-2988232.jpeg" },
    { index: 6, shortName: "gl", name: "General Ledger", href: "/gl/", available: false, comingSoon: false, image: "https://images.pexels.com/photos/8296977/pexels-photo-8296977.jpeg" },
    { index: 7, shortName: "fa", name: "Fixed Asset", href: "/fa/", available: false, comingSoon: false, image: "https://images.unsplash.com/photo-1758695537300-cc5f7c85a578?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1170" },
    { index: 8, shortName: "ai", name: "Chat Bot AI", href: "/ai/", available: false, comingSoon: true, image: "https://images.unsplash.com/photo-1694903089438-bf28d4697d9a?q=80&w=1632&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" }
  ];

  products: Product[] = this.productsWithImage;
  allowApp: Product[] = [];

  isShowSidebarButton: boolean = document.documentElement.clientWidth < 600;

  @HostListener('window:resize', ['$event'])
  updateWidth(): void {
    const viewportWidth = document.documentElement.clientWidth;
    if (viewportWidth < 600) {
      this.isShowSidebarButton = true;
    } else {
      this.isShowSidebarButton = false;
    }
  }

  ngOnInit(): void {
    window.addEventListener('resize', this.updateWidth.bind(this));
    this.handleRedirect();
    this._authService.initForLanding();

    if (!this._userService.isLogin()) {
      this._router.navigate(['/login']);
    } else {
      this._userService.requestLanding((hotels: UserHotel.HotelResponseDTO[] | undefined) => {
        this.loaded = true;
        if (hotels == undefined) {
          this.alertHTML(this.landingFailMessage, "error", false, undefined);
          this._userService.clearCookie();
          window.location.assign("/login");
        } else if (hotels.length == 0) {
          this.formHotel.disable();
        } else if (hotels.length == 1) {
          this.formHotel.enable();
          this.handleDisableApp(hotels[0]);
          this.onSetDefaultFoApp(hotels[0]);
          if (this.allowApp.length === 1) {
            this.loaded = false;
            this.applyForHotel(hotels[0], this.allowApp[0].href);
          }
          this._userService.applyHotelSidebar(hotels.length);
        } else {
          this.formHotel.enable();
          this.hotels = hotels;
          this._userService.applyHotelSidebar(hotels.length);
        }
      });
    }

    this.filteringCtrl.valueChanges.subscribe((value: any) => {
      this.searchingText = value
    });

    this.formHotel.valueChanges.subscribe((value) => {
      if (value && value.id) {
        this.handleDisableApp(value);
        this.onSetDefaultFoApp(value);
      }
    });
  }

  handleDisableApp(hotel: UserHotel.HotelResponseDTO) {
    this.products.forEach((el) => {
      if (hotel.app_right && hotel.app_right[el.shortName as keyof typeof hotel.app_right]) {
        el.enabled = true;
      } else {
        el.enabled = false;
      }
    });
    this.products.sort((a, b) => {
      if (a.enabled && !b.enabled) return -1;
      if (!a.enabled && b.enabled) return 1;
      return a.index - b.index;
    });
  }

  onSetDefaultFoApp(hotel: UserHotel.HotelResponseDTO) {
    if (hotel.app_right) {
      this.allowApp = this.products.filter(el => !el.enabled);
      if (this.allowApp.length === 0) {
        const foApp = this.products.filter(el => el.shortName === "fo");
        foApp[0].enabled = true;
        this.allowApp = foApp;
      }
    } else {
      const foApp = this.products.filter(el => el.shortName === "fo");
      foApp[0].enabled = true;
      this.allowApp = foApp;
    }
  }

  async applyForHotel(hotel: UserHotel.HotelResponseDTO, appHref: string) {
    if (hotel.id == undefined) {
      this.formHotel.disable();
      return;
    } else {
      const hotelId = hotel.id;
      this.onSetDefaultFoApp(hotel);
      this._hotelService.requestCheckHotelLicense(hotelId, async (expiredInfo: HotelConfig.LicenseInformation) => {
        let remainingDays = Number(expiredInfo.days);
        let expiredIn = new Date();
        expiredIn.setDate(expiredIn.getDate() + remainingDays);
        if (expiredInfo.expired == true) {
          this.alertHTML(`<a href>${this._languagesService.getTextForTs("form_landing_app.please_contact_support")}</a>`, "error", false, this._languagesService.getTextForTs("form_landing_app.license_expired"));
        } else {
          const closeDayCheck = await this._frontService.requestCloseDayCheck(hotelId);
          if (closeDayCheck.state) {
            this.applyHotelSelected(hotelId, appHref);
            return;
          }
          this._centralizedService.requestSystemDate(hotelId, () => {
            this._frontService.requestAllSystemConfig(hotelId, () => {
              if (expiredInfo.expiredSoon == true) {
                this.alertHTML(undefined, "warning", false, `${this._languagesService.getTextForTs("form_landing_app.license_will_expire_soon")} ${expiredIn.toISOString().slice(0, 10)}`)
                .then(() => this.applyHotelSelected(hotelId, appHref));
              } else {
                this.applyHotelSelected(hotelId, appHref);
              }
            });
          });
        }
      });
    }
  }

  applyHotelSelected(hotelId: string, appHref: string) {
    this._userService.requestLandingSelectHotel(hotelId).then((result) => {
      if (!result || !result[0]) {
        this.alertHTML(undefined, "warning", false, this._userService.alertMsg);
        return;
      }
      this._hotelService.getHotelBackground(hotelId, () => {
        this._userService.applyHotelSelected(hotelId, result[0]);
        if (this.redirectURL != undefined) {
          window.location.assign(this.redirectURL);
          return;
        }
        window.location.assign(appHref);
      });
    }).catch((error) => {
      this.alertHTML(undefined, "error", false, this._userService.alertMsg);
    });
  }

  private handleRedirect() {
    const redirect: any = this._activeRoute.snapshot.queryParamMap.get('redirect');
    if (redirect != undefined) {
      const redirectDecoded = base64.decodeString(redirect, false);
      this.redirectURL = redirectDecoded;
    }
  }

  onLogout() {
    this._userService.logout().finally(() => window.location.assign('/login/'));
  }

  selectAppClick(appHref: Product) {
    if (!this.formHotel.value || !appHref.enabled) return;
    this.applyForHotel(this.formHotel.value, appHref.href);
  }

  alertHTML(msg: string | undefined, icon: SweetAlertIcon, showCancelButton: boolean, title: string | undefined) {
    return Swal.fire({
      heightAuto: false,
      title: title,
      html: msg ? `<pre>${msg}<pre>` : undefined,
      icon: icon,
      showConfirmButton: true,
      showCancelButton: showCancelButton,
      confirmButtonText: showCancelButton ? this._languagesService.getTextForTs("global.button.yes") : this._languagesService.getTextForTs("global.button.ok"),
      cancelButtonText: this._languagesService.getTextForTs("global.button.no"),
      customClass: environment.alert_sweet,
      buttonsStyling: false,
      allowOutsideClick: false
    });
  }

  handleImageLoad(image: HTMLElement, placeholder: HTMLElement, productStatus?: HTMLElement) {
    image?.classList.add('loaded');
    setTimeout(() => {
      placeholder?.classList.add('hidden');
    }, 600);
  }

  handleImageError(placeholder: HTMLElement) {
    if (!placeholder) return;
    setTimeout(() => {
      placeholder.innerHTML = `
      <div class="error-circle">!</div>
      <span class="loading-text" style="color: #94a3b8;">Can't load image</span>
      `;
      placeholder.classList.remove('skeleton');
      placeholder.classList.add('error-container');
    }, 600);
  }

  getBadgeInfo(product: Product): { class: string, displaytext: string } {
    let obj = {
      class: "",
      displaytext: ""
    };
    if (product.enabled) {
      if (product.available) {
        obj.class = "available";
        obj.displaytext = "Available now!";
      }
      else if (product.comingSoon) {
        obj.class = "coming-soon";
        obj.displaytext = "Coming soon!";
      }
    }
    return obj;
  }
}

interface Product {
  index: number;
  shortName: string;
  name: string;
  href: string;
  image: string;
  enabled?: boolean;
  available?: boolean;
  comingSoon?: boolean;
  info?: string;
}